import type { TableCellProps } from '@mui/material';
import { tasksPageStyles } from './styles.ts';

export const tasksPageText = {
  pageTitle: 'Мої завдання',
  pageSubtitle: 'Поточні дії, які потребують уваги менеджера.',
  roleFilterTitle: 'Наявні ролі',
  selectAllRolesButton: 'Усі ролі',
  clearRolesButton: 'Скинути',
  emptyFilteredTitle: 'Немає задач за вибраними ролями',
  emptyFilteredText: 'Оберіть інші ролі або поверніть відображення всіх доступних ролей.',
  emptyRolesTitle: 'Немає доступних ролей для задач',
  emptyRolesText: "Для поточного користувача не знайдено ролей, пов'язаних із задачами.",
  taskLabel: 'Завдання',
  deadlineLabel: 'Дедлайн',
  statusLabel: 'Статус',
  actionLabel: 'Дія',
  actionButton: 'Обрати дію',
  viewActionLabel: 'Переглянути заявку',
  takeInWorkActionLabel: 'Взяти в роботу',
  refuseTaskActionLabel: 'Відмовитись',
  actionInProgressLabel: 'Виконується...',
  guaranteesLoadingText: 'Завантажуємо задачі PM-менеджера...',
  guaranteesErrorText: 'Не вдалося завантажити задачі PM-менеджера.',
  guaranteesCounterpartyLabel: 'Контрагент',
  guaranteesApplicationDateLabel: 'Дата заявки',
  guaranteesSlaLabel: 'Дедлайн',
  guaranteesSlaOverdueLabel: 'Прострочено',
  guaranteesExecutorLabel: 'Призначений',
  assignExecutorActionLabel: 'Призначити виконавця',
  assignExecutorDialogTitle: 'Призначення виконавця',
  assignExecutorFieldLabel: 'Виконавець',
  assignExecutorSaveButton: 'Зберегти',
  assignExecutorCancelButton: 'Скасувати',
  assignExecutorLoadingText: 'Завантажуємо доступних виконавців...',
  assignExecutorEmptyText: 'Немає доступних виконавців',
  assignExecutorErrorText: 'Не вдалося завантажити доступних виконавців.',
  assignExecutorSuccessText: 'Виконавця призначено.',
  urgentTaskLabel: 'Терміново',
  emptyValue: '-',
} as const;

type TTaskTableColumnKey = keyof typeof tasksPageStyles.tableCellSize;

export type TTaskTableHeadColumn = {
  key: TTaskTableColumnKey;
  label: string;
  headCellType: string;
  align?: TableCellProps['align'];
};

export const TASKS_GUARANTEES_TABLE_COLUMNS: TTaskTableHeadColumn[] = [
  {
    key: 'subject',
    label: tasksPageText.guaranteesCounterpartyLabel,
    headCellType: 'document',
  },
  {
    key: 'deadline',
    label: tasksPageText.guaranteesApplicationDateLabel,
    headCellType: 'createdAt',
    align: 'center',
  },
  {
    key: 'sla',
    label: tasksPageText.guaranteesSlaLabel,
    headCellType: 'sla',
    align: 'center',
  },
  {
    key: 'status',
    label: tasksPageText.statusLabel,
    headCellType: 'status',
    align: 'center',
  },
  {
    key: 'executor',
    label: tasksPageText.guaranteesExecutorLabel,
    headCellType: 'executor',
    align: 'center',
  },
  {
    key: 'action',
    label: tasksPageText.actionLabel,
    headCellType: 'actions',
    align: 'center',
  },
];

export const TASKS_ROWS_PER_PAGE = 5;
export const TASKS_MANAGER_TASKS_DATE_SORT_KEY = 'createdAt';
